import { createTicket } from "library/api/zendesk/zendesk";
import { getIsProduction } from "library/browser";
import { FormValues } from "../../pages/ThirdPartyAuthority/types";
import { thirdPartyCustomFieldsMap as customFieldsMap } from "./customFieldsMap";
import { formatDate, formatDate2 } from "./zendeskAPI";

const FORM_ID_AU = { prod: 360000130337, nonProd: 360000233637 };

const GROUP_ID_AU = { prod: 360002312898, nonProd: 360004390118 };

export interface GetThirdPartyAuthorityParams extends FormValues {
  userName: string;
  userEmail: string;
  token: string;
  last4Digits: string;
}

const productsCustomFieldOptions = [
  "credit_card_or_store_card",
  "personal_loan",
  "car/_motor_loan",
];

export const createThirdPartyAuthorityTicket = async ({
  userName,
  userEmail,
  accounts,
  token,
  ...fields
}: GetThirdPartyAuthorityParams) => {
  const isProduction = getIsProduction();
  const envKey = isProduction ? "prod" : "nonProd";

  const accountsFields = Object.values(accounts).map((account, index) => ({
    id: customFieldsMap[`Account ${index + 1}`],
    value: account,
  }));

  const productsValue = [fields.products1, fields.products2, fields.products3]
    .map((pr, index) => (pr ? productsCustomFieldOptions[index] : null))
    .filter(Boolean) as string[];

  const ticketResponse = await createTicket(
    {
      isNZ: false,
      requester: {
        email: userEmail,
        name: userName,
      },
      ticketFormId: FORM_ID_AU[envKey],
      groupId: GROUP_ID_AU[envKey],
      subject: "Third Party Authority",
      comment:
        "Third Party Authority letter originating from the Latitude Service Centre (LSC).",
      customFields: [
        { id: customFieldsMap["Last 4 digits"], value: fields.last4Digits },
        {
          id: customFieldsMap["Customers first name"],
          value: fields.firstName,
        },
        {
          id: customFieldsMap["Surname  (as it appears on ID)"],
          value: fields.lastName,
        },
        {
          id: customFieldsMap.DOB,
          value: formatDate(fields.dateOfBirth),
        },
        { id: customFieldsMap["Mobile Number"], value: fields.mobileNumber },
        {
          id: customFieldsMap["Relationship to account (without ATP)"],
          value: "account_holder_relationship_to_acc_v2",
        },
        {
          id: customFieldsMap["add or remove an authorised party?"],
          value: fields.action,
        },
        {
          id: customFieldsMap[" Primary contact"],
          value: fields.primaryContact,
        },
        { id: customFieldsMap["Other Information"], value: fields.other },
        { id: customFieldsMap["Product(s) "], value: productsValue },
        {
          id: customFieldsMap["Authority level"],
          value: fields.authorityLevel,
        },
        {
          id: customFieldsMap["Organisation or Financial Counsellor?"],
          value: fields.organisationOrFinancialCounsellor,
        },
        {
          id: customFieldsMap["Authority level"],
          value: fields.authorityLevel,
        },
        {
          id: customFieldsMap["Full Name "],
          value: fields.nominatedFullName,
        },
        {
          id: customFieldsMap["ATP or POA Full Name"],
          value: `${fields.firstName} ${fields.lastName}`,
        },
        {
          id: customFieldsMap["DOB 2"],
          value: formatDate2(fields.dateOfBirth2),
        },
        {
          id: customFieldsMap.Address,
          value: fields.address,
        },
        {
          id: customFieldsMap["Suburb or City"],
          value: fields.suburb,
        },
        {
          id: customFieldsMap.State,
          value: fields.state,
        },
        {
          id: customFieldsMap["Removal type"],
          value: fields.removalType,
        },
        {
          id: customFieldsMap["Postcode AU/NZ"],
          value: fields.postcode,
        },
        {
          id: customFieldsMap.Phone,
          value: fields.contactNumber,
        },
        {
          id: customFieldsMap["TPA Email Address"],
          value: fields.email,
        },
        {
          id: customFieldsMap["Contact name"],
          value: fields.contactName,
        },
        {
          id: customFieldsMap[
            "Hardship: Organisation or Financial Counsellor name"
          ],
          value: fields.organisationOrFinancialCounsellorsName,
        },

        ...accountsFields,
      ],
    },
    token,
  );

  return ticketResponse.data.ticket_id;
};
